import { fetchWrapper } from '@/_helpers';

export const conferenceApi = {
    getChannelMessages: (roomId, page = 1, limit = 15) =>
        fetchWrapper.get(`chatrooms/${roomId}/messages?sortBy=createdAt:desc&limit=${limit}&page=${page}`),
    postChatMessage: (conferenceId, text) =>
        fetchWrapper.post(`conference/${conferenceId}/chat-message`, { text }),
    guestJoin: (conferenceId, data) => fetchWrapper.post(`conference/${conferenceId}/guest/join`, data),
    guestRequest: (conferenceId) => fetchWrapper.post(`conference/${conferenceId}/guest/request`),
    guestApprove: (conferenceId, data) => fetchWrapper.post(`conference/${conferenceId}/guest/approve`, data),
    startRecording: (conferenceId) =>
        fetchWrapper.post(`conference/${conferenceId}/recording`, {
            action: 'start',
        }),
    stopRecording: (conferenceId) =>
        fetchWrapper.post(`conference/${conferenceId}/recording`, {
            action: 'stop',
        }),

    updateConference: (conferenceId, data) => fetchWrapper.put(`conference/${conferenceId}/update`, data),
    retryRecording: (conferenceId) => fetchWrapper.post(`conference/${conferenceId}/recording/retry-save`),
};
